import { CalendarBirthdayEventDisplayItem, CalendarBookingDisplayItem, CalendarEventDisplayItem, CalendarRepertoirePerformanceDisplayItem, EventLocationDisplayItem, TeacherDisplayItem, TeacherPrivilegesAndSettingsDisplayItem } from "@sb/library/data-models";
import { MbscCalendarColor, MbscCalendarEvent } from "@mobiscroll/angular";
import { IconItem } from "./icon.definitions";

export enum CalendarView {
    Month,
    Week,
    Day,
    Agenda,
    Timeline
}

export enum CalendarEventKind {
    Birthday,
    Calendar,
    RepertoirePerformance,
    BookingSlot,
} 

export enum CalendarEventAttendanceStatus {
    AllUnrecorded,
    AtLeastOnePresent,
    AllPresent,
    AtLeastOneAbsent,
    AllAbsent
}

export enum CalendarEventColorTheme {
    Light = "Light",
    HighContrast = "HighContrast"
}

export enum CalendarEventLabelMode {
    Detailed = "Detailed",
    Simple = "Simple"
}

export enum CalendarEventStudentLabelMode {
    Number = "Number",
    Names = "Names"
}

export interface SchoolBoxCalendarEvent extends MbscCalendarEvent {
    kind: CalendarEventKind;
    data: CalendarBirthdayEventDisplayItem | CalendarRepertoirePerformanceDisplayItem | CalendarEventDisplayItem | CalendarBookingDisplayItem;
    birthdayData?: CalendarBirthdayEventDisplayItem;
    calendarData?: CalendarEventDisplayItem;
    bookingSlotData?: CalendarBookingDisplayItem[];
    repertoirePerformanceData?: CalendarRepertoirePerformanceDisplayItem;
}

export class CalendarRepertoirePerformance {
    RepertoireTitle!: string;
    StudentNames!: string[];
}

export type SchoolBoxCalendarEventData<T> =   T extends CalendarEventKind.Birthday ? CalendarBirthdayEventDisplayItem
                                            : T extends CalendarEventKind.RepertoirePerformance ? CalendarRepertoirePerformanceDisplayItem
                                            : T extends CalendarEventKind.BookingSlot ? CalendarBookingDisplayItem
                                            : T extends CalendarEventKind.Calendar ? CalendarEventDisplayItem
                                            : never;

export class CalendarAttendanceStatusIcon {
    Icon!: IconItem;
    Color!: string;
}

export class CalendarEventsCount {
    Birthday: Array<CalendarBirthdayEventDisplayItem> = [];
    Repertoire: Array<CalendarRepertoirePerformanceDisplayItem> = [];
    Calendar: Array<CalendarEventDisplayItem> = [];
    BookingSlot: Array<boolean> = [];
}

export class CalendarEventDot {
    Color!: string;
}

export enum CalendarEventColorKind {
    Default,
    Inverse,
    Border
}

export interface CalendarDragAndDropItem {
    StartDate: string;
    EndDate: string;
    Resource: string;
}

export class CalendarDrawableColors {
    CurrentTime: MbscCalendarColor[] = [];
    TodayShading: MbscCalendarColor | null = null;
    Unavailabilities: {Teacher: MbscCalendarColor[], Location: MbscCalendarColor[]} = {
        Teacher: [],
        Location: []
    }
}
